
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form4Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false; 
    hasDebt = false;  
    creditorList = [];
    hasUnusualExpense = false;
    unusualExpenseDetails = '';
    hasLegalDutyAdult = false;
    adultList = [];
    hasLegalDutyChild = false;
    childList = [];
    hasOtherHardship = false;
    otherHardshipDetails = '';
   
    mounted(){
        this.dataReady = false;        
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){        
        this.getCreditorInfo();  
        this.getHighExpenseInfo();  
        this.getAdultInfo();
        this.getChildInfo();
        this.getOtherInfo();
    } 

    public getCreditorInfo(){ 
        
        this.hasDebt = false;

        if(this.result?.undueHardshipFsExists)
            this.hasDebt = this.result.undueHardshipFsExists == 'Yes'; 
        
        this.creditorList = [];

        if( this.hasDebt && this.result?.undueHardshipFSSurvey){

            for(const debtInfo of this.result.undueHardshipFSSurvey){

                let debt = {
                    name: debtInfo.creditorFullName?debtInfo.creditorFullName:'', 
                    reason: debtInfo.debtReason?debtInfo.debtReason:'',
                    balance: debtInfo.debTotal?Number(debtInfo.debTotal):0,
                    payment: debtInfo.debtAnnualPayment?Number(debtInfo.debtAnnualPayment):0
                }                
                this.creditorList.push(debt);
            } 
        }
    }

    public getHighExpenseInfo(){ 

        this.hasUnusualExpense = false;
        this.unusualExpenseDetails = '';
        
        if(this.result?.unusuallyHighExpensesFSSurvey){
            const unusualExpense = this.result.unusuallyHighExpensesFSSurvey;
            this.hasUnusualExpense = unusualExpense.unusualExpensesExist == 'y';
            this.unusualExpenseDetails = unusualExpense.unusualExpensesDetails?unusualExpense.unusualExpensesDetails:'';           
        }
            
    }

    public getAdultInfo(){ 
        
        this.hasLegalDutyAdult = false;
        if(this.result?.legalDutyAnotherPersonFsExists)
            this.hasLegalDutyAdult = this.result.legalDutyAnotherPersonFsExists == 'Yes'; 
        
        this.adultList = [];

        if( this.hasLegalDutyAdult && this.result?.legalDutyAnotherPersonFSSurvey){

            for(const adultInfo of this.result.legalDutyAnotherPersonFSSurvey){

                let adult = {
                    name: adultInfo.antherPersonFullName?adultInfo.antherPersonFullName:'', 
                    monthly: adultInfo.monthlyPayment?Number(adultInfo.monthlyPayment):0,
                    yearly: adultInfo.yearlyPayment?Number(adultInfo.yearlyPayment):0
                }                
                this.adultList.push(adult);
            }
        }
    }

    public getChildInfo(){ 
        
        this.hasLegalDutyChild = false;
        if(this.result?.legalDutyDependentChildFsExists)
            this.hasLegalDutyChild = this.result.legalDutyDependentChildFsExists == 'Yes'; 
        
        this.childList = [];

        if( this.hasLegalDutyChild && this.result?.legalDutyDependentChildFSSurvey){

            for(const childInfo of this.result.legalDutyDependentChildFSSurvey){

                let child = {
                    name: childInfo.childFullName?childInfo.childFullName:'', 
                    monthly: childInfo.monthlyPayment?Number(childInfo.monthlyPayment):0,
                    yearly: childInfo.yearlyPayment?Number(childInfo.yearlyPayment):0
                }                
                this.childList.push(child);
            }
        }    
    }

    public getOtherInfo(){ 

        this.hasOtherHardship = false;
        this.otherHardshipDetails = '';        
        if(this.result?.otherCircumstancesFSSurvey){
            const otherInfo = this.result.otherCircumstancesFSSurvey;
            this.hasOtherHardship = otherInfo.otherCircumstancesExist == 'y';
            this.otherHardshipDetails = otherInfo.otherCircumstancesDetails?otherInfo.otherCircumstancesDetails:''
        }

    }
 
}
